<div [ngClass]="{ inline: isInline }" class="fullModal opened addForm" id="AddGatewayModal">
  <app-loader [isLoading]="isLoading"></app-loader>

  @if (!isComplete && !isLoading) {
    <div class="fullRow" id="Stage2">
      <div class="title" style="filter: brightness(50%)">Create A New Gateway</div>
      <div class="subtitle">Enter your Gateway attributes</div>
      <div class="sized">
        <div class="label row">
          Gateway Name
          <span [hidden]="!errorNameLength" class="error">Name must be at least 5 characters</span>
          <span [hidden]="errorNameLength" class="note">Required</span>
        </div>
        <div class="row">
          <input
            [(ngModel)]="model.name"
            [ngClass]="{ error: errorName }"
            class="restrictNormal"
            id="EditName"
            maxlength="{{ maxLength }}"
            minlength="5"
            placeholder="What would you like to call this gateway?"
            type="text"
            />
          </div>
          <!-- VCPEGW -->
          <!-- <div class="label row"><span class="private">Cloud </span>Region<span class="error" [hidden]="!errorRegion">Required</span><span class="note" [hidden]="errorRegion">Required</span></div>
          <div class="row">
            <select id="RegionList" class="regions" [ngClass]="{error:errorRegion}" type="text" placeholder="Select a Cloud Region" [(ngModel)]="model.geoRegionId" (keyup.enter)="save()">
              <option value="">Select A Region</option>
              <option *ngFor="let region of regions | sortby: 'name'" [value]="region.id">{{ region.name }}</option>
            </select>
          </div> -->
          <app-country-list [errorCountry]="errorRegion || errorLocation" [model]="model"></app-country-list>
          @if (showBreakoutFields) {
            <div>
              <div class="label row">
                O365 Breakout Next Hop IP
                <span [hidden]="!errorNextHop" class="error">Invalid</span>
                <span [hidden]="errorNextHop" class="note">Optional</span>
              </div>
              <div class="row">
                <input
                  [(ngModel)]="model.o365BreakoutNextHopIp"
                  [ngClass]="{ error: errorNextHop }"
                  class="restrictNormal"
                  id="NextHopIp"
                  placeholder="Next Hop IP"
                  type="text"
                  />
                </div>
              </div>
            }
            @if (!netflowEnabled && !hideHaUpgrade && authorizationService.canCreateGatewayClusters()) {
              <div>
                <div class="label row">Enable High Availablity<span class="note">Enable to Edit Details</span></div>
                <div class="row">
                  <div class="darkGrid">
                    <div class="title">
                      <div class="icon-ha"></div>
                    </div>
                    <div class="subtitle">
                      ENABLE HIGH AVAILABILITY<br />
                      FOR ULTIMATE REDUNDANCY
                    </div>
                    <div>
                      <div class="switchGrid">
                        <div>
                          <div (click)="toggleHAGateway()" [ngClass]="{ on: isHAGateway }" class="toggle">
                            <span [hidden]="!isHAGateway">ON&nbsp;&nbsp;&nbsp;</span>
                            <span [hidden]="isHAGateway">&nbsp;&nbsp;&nbsp;OFF</span>
                            <div class="switch"></div>
                          </div>
                        </div>
                        <div>
                          <span [hidden]="!isHAGateway">Enabled</span>
                          <span [hidden]="isHAGateway">Disabled</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (!isHAGateway && collectors.length > 0) {
              <div class="label row labelExpansion">
                Advanced Options<span class="note">Open to Edit Details</span>
              </div>
            }
            @if (!isHAGateway && collectors.length > 0) {
              <div class="row expansion">
                <mat-accordion>
                  <mat-expansion-panel #panel [hideToggle]="true">
                    <mat-expansion-panel-header [collapsedHeight]="'4.0625rem'">
                      <mat-panel-title class="expansionLabel">
                        <div class="title">
                          <div class="icon-AdvancedOptions"></div>
                        </div>
                        <div class="subtitle">Advanced Options</div>
                        <span
                          [ngClass]="{ open: panel.expanded }"
                          class="expansion-indicator icon-Sort_Down"
                        ></span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-grid-list cols="10" rowHeight="2.8125rem">
                      <mat-grid-tile [colspan]="9">
                        <div class="label netflowFieldLabel">Netflow</div>
                      </mat-grid-tile>
                      <mat-grid-tile [colspan]="1">
                        <div class="toggleTile">
                          <div
                            (click)="toggleNetflowEnabled()"
                            [ngClass]="{ on: netflowEnabled }"
                            class="toggle gridToggle"
                            id="IcmpToggle"
                            >
                            <span [hidden]="!netflowEnabled" id="NetflowToggleOn"
                              >ON&nbsp;&nbsp;&nbsp;</span
                              >
                              <span [hidden]="netflowEnabled" id="NetflowToggleOff"
                                >&nbsp;&nbsp;&nbsp;OFF</span
                                >
                                <div class="switch"></div>
                              </div>
                            </div>
                          </mat-grid-tile>
                          @if (netflowEnabled) {
                            <mat-grid-tile [colspan]="5">
                              <div class="label netflowFieldLabel">Collector</div>
                            </mat-grid-tile>
                          }
                          @if (netflowEnabled) {
                            <mat-grid-tile [colspan]="5">
                              <select
                                [(ngModel)]="exportModel.collectorId"
                                [ngClass]="{ error: errorCollector }"
                                class="collectors netflowField"
                                id="CollectorList"
                                placeholder="Select a Netflow Collector"
                                >
                                <option value="">Select A Netflow Collector</option>
                                @for (collector of collectors | sortby: 'name'; track collector) {
                                  <option
                                    [value]="collector.id"
                                    >
                                    {{ collector.name }}
                                  </option>
                                }
                              </select>
                            </mat-grid-tile>
                          }
                          @if (netflowEnabled) {
                            <mat-grid-tile [colspan]="5">
                              <div class="label netflowFieldLabel">Update Frequency (in seconds)</div>
                            </mat-grid-tile>
                          }
                          @if (netflowEnabled) {
                            <mat-grid-tile [colspan]="5">
                              <input
                                [(ngModel)]="exportModel.exportIntervalSeconds"
                                [ngClass]="{ error: errorFrequency }"
                                class="netflowField"
                                id="EditFrequency"
                                max="300"
                                min="1"
                                placeholder="the frequency the collector updates in seconds"
                                type="number"
                                />
                              </mat-grid-tile>
                            }
                          </mat-grid-list>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  }
                  @if (model.geoRegionId) {
                    <div class="row buttonRow right" style="margin-top: 1.25rem">
                      @if (!processing) {
                        <button (click)="save()" class="save" id="SaveGatewayButton">Create</button>
                      }
                      @if (processing) {
                        <button class="save confirm" disabled>Saving <span class="spinner"></span></button>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div [hidden]="!isComplete || isLoading" class="fullRow" id="Stage3">
              <div class="title">congratulations</div>
              <div class="subtitle">Your Gateway {{ completedTitleStatusString }}</div>
              <div [ngClass]="{ building: isBuilding, created: !isBuilding }" class="row center">
                @if (isBuilding) {
                  <span class="completedEndpointBubble">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle
                        class="path"
                        cx="50"
                        cy="50"
                        fill="none"
                        r="20"
                        stroke-miterlimit="10"
                        stroke-width="5"
                      ></circle>
                    </svg>
                  </span>
                }
              </div>

              <div>
                @for (gateway of gateways; track gateway; let index = $index) {
                  <div class="row">
                    <div class="sized">
                      @if (!zitiEnabledService.zitiPure) {
                        <div>
                          <div [hidden]="gateways.length === 0" class="label row">
                            {{ gateway.name }} Registration Key<span class="note">Click to Copy</span>
                          </div>
                          <div class="row">
                            <input
                              (click)="gatewayFormService.copy(gateway)"
                              [(ngModel)]="gateway.registrationKey"
                              class="RegKey"
                              data-enter="SaveButton"
                              id="RegKey_{{ gateway.id }}"
                              readonly
                              style="margin-bottom: 0.625rem"
                              type="text"
                              />
                            </div>
                          </div>
                        }
                        @if (zitiEnabledService.zitiPure) {
                          <div>
                            <div class="label row">
                              {{ gateway.name }} Registration Key<span class="note">Tap To Download</span>
                            </div>
                            <div class="row">
                              <div (click)="downloadJWT(gateway, index)" class="downloadButton">
                                <div class="DownloadKey"></div>
                                <div>DOWNLOAD KEY</div>
                                <div class="TapToDownload"></div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>

                <div class="subtitle">Download and install instructions</div>

                <div class="row center">
                  <div (click)="gatewayFormService.openDownloads()" class="buttonCard shadow openable">
                    <div class="gwdownloadicons" style="background-image: url(/assets/svgs/Icon_Download.svg)"></div>
                    <div class="title">Download Install Package</div>
                    <div class="content">
                      vCPE Gateway to connect to private networks, branches, & data centers using this customer-managed
                      virtual gateway.
                    </div>
                    <div class="row center buttonArea">
                      <button class="save" href="/app-downloads">Download</button>
                    </div>
                  </div>
                  <div
                (click)="
                    gatewayFormService.openUrl(
                        'https://netfoundry.zendesk.com/hc/en-us/articles/360016129312-Launch-a-NetFoundry-vCPE-gateway-on-a-hypervisor'
                    )
                "
                    class="buttonCard shadow"
                    >
                    <div class="gwdownloadicons" style="background-image: url(/assets/svgs/Icon_Doc.svg)"></div>
                    <div class="title">View Install Instructions</div>
                    <div class="content">
                      Connect public or private IP space inside your vCPE using a customer-managed cloud gateway.
                    </div>
                    <div class="row center buttonArea">
                      <button class="save">View</button>
                    </div>
                  </div>
                </div>
              </div>
              <div (click)="hideForm()" class="buttonBall close" id="CloseGatewayButton">
                <div class="buttonLabel">ESC</div>
              </div>
              @if (!hideHelp) {
                <app-form-support-button></app-form-support-button>
              }
              <div class="private">
                @if (authorizationService.canShareEndpoint(model.id)) {
                  <div
                    (click)="share()"
                    [hidden]="!isComplete"
                    class="buttonBall share"
                    id="ShareGatewayButton"
                    >
                    <div class="buttonLabel">SHARE</div>
                  </div>
                }
              </div>
              <div (click)="goBack()" [hidden]="isLoading || isComplete" class="buttonBall back" id="BackGatewayButton">
                <div class="buttonLabel">BACK</div>
              </div>
            </div>
